export class ServerError extends Error {}

export default { ServerError };
